var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var StyledIconButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  background: none;\n  margin: 0;\n  padding: 0;\n  cursor: ", ";\n  outline: none;\n"], ["\n  border: none;\n  background: none;\n  margin: 0;\n  padding: 0;\n  cursor: ", ";\n  outline: none;\n"])), function (props) { return (props.disabled ? 'default' : 'pointer'); });
export default StyledIconButton;
var templateObject_1;
